export class DocumentTypeMasterVm {
    DocumentTypeId: number = 0;
    DocumentName: string = '';
    DocumentCode: string = '';
    Description: string = '';
    FormatNo: string = '';
    IsActive: boolean = true;
    CreatedById: number = 0;
    CreatedByName: string = '';
    CreatedOn: Date = new Date();
    LastUpdatedById: number | null = null;
    LastUpdatedByName: string = '';
    LastUpdatedOn: Date | null = null;
    // UI-specific properties for nested table
    ExpandRecord?: boolean = false;
    Versions?: DocumentVersionVm[] = [];
    ActiveDocumentNo?: string = '';
}

export class DocumentVersionVm {
    DocumentVersionId: number = 0;
    DocumentTypeId: number = 0;
    DocumentName: string = '';
    DepartmentId: number | null = null;
    DepartmentName: string = '';
    VersionNo: string = '';
    FormatNo: string = '';
    EffectiveDate: string = '';
    ReviewDate: string = '';
    IsActive: boolean = true;
    CreatedById: number = 0;
    CreatedByName: string = '';
    CreatedOn: Date = new Date();
    LastUpdatedById: number | null = null;
    LastUpdatedByName: string = '';
    LastUpdatedOn: Date | null = null;
    LastActionBy: string = '';
    LastActionOn: Date | null = null;
    LastActionStatus: string = '';
    Remark: string = '';
}

export class DocumentRequestVm {
    DocumentTypeId: number | null = null;
    IsActive: boolean | null = null;
    SearchTerm: string = '';
    PageNumber: number = 1;
    PageSize: number = 20;
}

export class ActiveDocumentVersionVm {
    DocumentName: string = '';
    FormatNo: string = '';
    VersionNo: string = '';
    EffectiveDate: string = '';
}

export class DocumentTimelineVm {
    DocumentTimelineId: number = 0;
    DocumentTypeId: number = 0;
    DocumentName: string = '';
    DocumentVersionId?: number | null = null;
    VersionNo?: string | null = '';
    Action: string = '';
    Status: string = '';
    ActionById: number = 0;
    ActionByName: string = '';
    ActionOn: Date = new Date();
    Remarks: string = '';
}
